import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import account from './modules/account'
import session from './modules/session'
import tenant from './modules/tenant'
import sysuser from './modules/sysuser'
import baseinfo from './modules/baseinfo'
import subschool from './modules/subschool'
import role from './modules/role'
import lesson from './modules/lesson'
import room from './modules/room'
import classes from './modules/class'
import student from './modules/student'
import dashboard from './modules/dashboard'
import setting from './modules/setting'
import msg from './modules/msg'
import reply from './modules/reply'
import wxuser from './modules/wxuser'
import good from './modules/good'
import order from './modules/order'
import wechat from './modules/wechat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    account,
    session,
    tenant,
    sysuser,
    baseinfo,
    subschool,
    role,
    lesson,
    room,
    classes,
    student,
    dashboard,
    setting,
    msg,
    reply,
    wxuser,
    good,
    order,
    wechat
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})
